import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createSolutionApi } from "../../services/solution/create.solution.api";
import { updateSolutionApi } from "../../services/solution/update.solution.api";

export const useUpdateSolutionApi = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (updateInfo: any) => updateSolutionApi(updateInfo),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["solution"],
      });
    },
  });
};
